import { gateway } from "../../../gateway";
import { IEventDeliveryConfig } from "../interfaces";

export const getEventDeliveryConfig = async (): Promise<IEventDeliveryConfig | null> => {
  const response = await gateway.get("/event-delivery/config");
  return response?.data?.data ?? null;
};
